import Mail from '../img/Mail.svg'
import In from '../img/linkedin.svg'

function ContactInfo() {
    return (
    <div>
      <h2 className="name">Omar Sosa</h2>
      <h1 className="title">Frontend Developer</h1>
      <a className="site" target='_blank' href="https://omars-journey.netlify.app/">omars-journey.netlify.app</a>
      <div className="contact">
        <div className="email">
          <img src={Mail}></img>
            <a className="email-link" href="mailto:omar.sosa.quimica@gmail.com">Email</a>
        </div>
        <div className="linkedin">
        <img src={In}></img>
            <a href='https://www.linkedin.com/in/omar-sosa-b5949a247/' target='_blank' className='linkedin-link'>LinkedIn</a>
        </div>
      </div>
    </div>
    );
  }
  
  export default ContactInfo;